import { useState, useEffect } from "react";
import { services } from "../../api";
import { LandDetail } from "../../interfaces/api/lands";
import environment from "../../environment/environment";

interface UseLandDetailResult {
  land: LandDetail | null;
  loading: boolean;
  error: string | null;
  fetchLandDetail: (id: number) => Promise<void>;
}

export const useLandDetail = (initialId?: number): UseLandDetailResult => {
  const [land, setLand] = useState<LandDetail | null>(null);
  const [loading, setLoading] = useState<boolean>(initialId !== undefined);
  const [error, setError] = useState<string | null>(null);

  const fetchLandDetail = async (id: number): Promise<void> => {
    try {
      setLoading(true);
      setError(null);

      const response = await services.lands.getLandDetail(id);
      setLand(response.content);
    } catch (err) {
      setError("Failed to fetch land details");
      if (environment.debug) console.error("Error fetching land details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialId !== undefined) {
      fetchLandDetail(initialId);
    }
  }, [initialId]);

  return {
    land,
    loading,
    error,
    fetchLandDetail,
  };
};
